import { SET_TOKEN, SET_EXPIREAT, SET_USERNAME, SET_GROUP, SET_ISSEARCHOTHER } from '@/constants/mutation_types'
import { setSession, getSession, clearSession } from '@/utils/session'
import { login, logout, register, change } from '@/api/user'

var session = getSession() || ''
const username = session ? session.username : ''
const expireAt = session ? session.expiresAt : ''
const group = session ? session.group : ''
const token = session ? session.authToken : ''

export default {
  namespaced: true,
  state: {
    token: token,
    expireAt: expireAt,
    username: username,
    group: group,
    isSearchOther: false
  },
  getters: {
    loggedIn: state => !!state.token,
    username: state => state.username
  },
  mutations: {
    [SET_TOKEN] (state, token) {
      state.token = token
    },
    [SET_EXPIREAT] (state, expireAt) {
      state.expireAt = expireAt
    },
    [SET_USERNAME] (state, username) {
      state.username = username
    },
    [SET_GROUP] (state, group) {
      state.group = group
    },
    [SET_ISSEARCHOTHER] (state, isSearchOther) {
      state.isSearchOther = isSearchOther
    }
  },
  actions: {
    registerWithUsername (context, newUser) {
      return new Promise((resolve, reject) => {
        register(newUser)
          .then(resp => {
            resolve(resp.data)
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    changePassword (context, passwordPair) {
      return new Promise((resolve, reject) => {
        change(passwordPair)
          .then(resp => {
            resolve(resp.data)
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    signInWithUsername ({ commit }, { username, password }) {
      return new Promise((resolve, reject) => {
        login({ username, password })
          .then(resp => {
            // eslint-disable-next-line
            const { username, group, access_token, expires } = resp.data
            setSession({ username, group, authToken: access_token, expiresIn: expires })
            commit('SET_TOKEN', access_token)
            commit('SET_EXPIREAT', expires * 1000 + Date.now())
            commit('SET_USERNAME', username)
            commit('SET_GROUP', group)
            resolve()
          })
          .catch(err => {
            // console.log('user.js', err.response.status_code)
            // if (err.response.status_code === 401)
            reject(err)
            throw new Error(err)
            // reject(err)
          })
      })
    },
    signOut ({ commit }) {
      return new Promise((resolve, reject) => {
        logout()
          .then(resp => {
            clearSession()
            commit('SET_TOKEN', '')
            commit('SET_EXPIREAT', '')
            commit('SET_USERNAME', '')
            commit('SET_GROUP', '')
            resolve()
          })
          .catch(err => reject(err))
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js